export const createDescriptorsRequests = (client) => ({
    listDescriptors: async (params) => {
        const { data, meta, links } = await client.api.get("descriptors", {
            params: params,
        });
        return { data, meta, links };
    },
    listMostUsedDescriptors: async (params) => {
        const { data, meta, links } = await client.api.get("descriptors/most_used", {
            params,
        });
        return { data, meta, links };
    },
    findDescriptor: async (params) => {
        const { data, meta, links } = await client.api.get(`descriptors/${params?.filter?.id}`, {
            params: params,
        });
        return { data, meta, links };
    },
    fetchDescriptor: async (id, params) => {
        const { data, meta } = await client.api.get(`descriptor/${id}`, {
            params: { ...params, filter: { id: id } },
        });
        return { data, meta };
    },
    createDescriptor: async (payload) => {
        const { data } = await client.api.create("descriptors", payload);
        return { data };
    },
    updateDescriptor: async (payload) => {
        const { data } = await client.api.request({
            type: "descriptors",
            url: `/descriptors/${payload?.id}`,
            method: "PATCH",
            body: payload,
        });
        return { data };
    },
    approveDescriptor: async (payload) => {
        const { data } = await client.api.request({
            type: "descriptors",
            url: `/descriptors/${payload?.id}/approve`,
            method: "PATCH",
            body: payload,
        });
        return { data };
    },
    rejectDescriptor: async (payload) => {
        const { data } = await client.api.request({
            type: "descriptors",
            url: `/descriptors/${payload?.id}/reject`,
            method: "PATCH",
            body: payload,
        });
        return { data };
    },
    assignDescriptorToGroups: async (payload) => {
        const { data } = await client.api.request({
            type: "descriptors",
            url: `/descriptors/${payload?.id}/assign`,
            method: "PATCH",
            body: payload,
        });
        return { data };
    },
});
//# sourceMappingURL=index.js.map